package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets19 {
  internal val PyramidCrosswordGuide_txt: AssetResource by lazy { init_PyramidCrosswordGuide_txt() }

  internal val americanGuide_part1_txt: AssetResource by lazy { init_americanGuide_part1_txt() }

  internal val americanGuide_part2_txt: AssetResource by lazy { init_americanGuide_part2_txt() }

  internal val browseGuide_txt: AssetResource by lazy { init_browseGuide_txt() }

  internal val completeVerseGuide_txt: AssetResource by lazy { init_completeVerseGuide_txt() }

  internal val create_sheet_for_open_questions_tutorial_txt: AssetResource by lazy {
      init_create_sheet_for_open_questions_tutorial_txt() }

  internal val donateText_txt: AssetResource by lazy { init_donateText_txt() }

  internal val draft_txt: AssetResource by lazy { init_draft_txt() }

  internal val help_txt: AssetResource by lazy { init_help_txt() }

  internal val mikudGuide_txt: AssetResource by lazy { init_mikudGuide_txt() }

  internal val open_questionsGuide_txt: AssetResource by lazy { init_open_questionsGuide_txt() }

  internal val randomApproach_txt: AssetResource by lazy { init_randomApproach_txt() }

  internal val searchExamples_txt: AssetResource by lazy { init_searchExamples_txt() }

  internal val searchGuide_txt: AssetResource by lazy { init_searchGuide_txt() }

  internal val shareTextHtml_txt: AssetResource by lazy { init_shareTextHtml_txt() }

  internal val shareText_txt: AssetResource by lazy { init_shareText_txt() }

  internal val simchatTorahMaftir_txt: AssetResource by lazy { init_simchatTorahMaftir_txt() }

  internal val test2_json: AssetResource by lazy { init_test2_json() }

  internal val test_txt__0: AssetResource by lazy { init_test_txt__0() }

  internal val comments_txt: AssetResource by lazy { init_comments_txt() }

  internal val draft2_json: AssetResource by lazy { init_draft2_json() }

  internal val draft_json: AssetResource by lazy { init_draft_json() }

  internal val pairs_json: AssetResource by lazy { init_pairs_json() }

  internal val test_txt__1: AssetResource by lazy { init_test_txt__1() }

  internal val moadim_txt: AssetResource by lazy { init_moadim_txt() }

  internal val parashot_json: AssetResource by lazy { init_parashot_json() }

  internal val names_10_melachim_a_01_txt: AssetResource by lazy { init_names_10_melachim_a_01_txt()
      }

  internal val names_10_melachim_a_02_txt: AssetResource by lazy { init_names_10_melachim_a_02_txt()
      }

  internal val names_10_melachim_a_03_txt: AssetResource by lazy { init_names_10_melachim_a_03_txt()
      }

  internal val names_10_melachim_a_05_txt: AssetResource by lazy { init_names_10_melachim_a_05_txt()
      }

  internal val names_10_melachim_a_09_txt: AssetResource by lazy { init_names_10_melachim_a_09_txt()
      }

  internal val names_10_melachim_a_10_txt: AssetResource by lazy { init_names_10_melachim_a_10_txt()
      }

  internal val names_10_melachim_a_11_txt: AssetResource by lazy { init_names_10_melachim_a_11_txt()
      }

  internal val names_10_melachim_a_14_txt: AssetResource by lazy { init_names_10_melachim_a_14_txt()
      }

  internal val names_10_melachim_a_15_txt: AssetResource by lazy { init_names_10_melachim_a_15_txt()
      }

  internal val names_10_melachim_a_16_txt: AssetResource by lazy { init_names_10_melachim_a_16_txt()
      }

  internal val names_10_melachim_a_19_txt: AssetResource by lazy { init_names_10_melachim_a_19_txt()
      }

  internal val names_10_melachim_a_20_txt: AssetResource by lazy { init_names_10_melachim_a_20_txt()
      }

  internal val names_10_melachim_a_21_txt: AssetResource by lazy { init_names_10_melachim_a_21_txt()
      }

  internal val names_10_melachim_a_22_txt: AssetResource by lazy { init_names_10_melachim_a_22_txt()
      }

  internal val names_10_melachim_a_txt: AssetResource by lazy { init_names_10_melachim_a_txt() }

  internal val names_11_melachim_b_05_txt: AssetResource by lazy { init_names_11_melachim_b_05_txt()
      }

  internal val names_11_melachim_b_07_txt: AssetResource by lazy { init_names_11_melachim_b_07_txt()
      }

  internal val names_11_melachim_b_08_txt: AssetResource by lazy { init_names_11_melachim_b_08_txt()
      }

  internal val names_11_melachim_b_09_txt: AssetResource by lazy { init_names_11_melachim_b_09_txt()
      }

  internal val names_11_melachim_b_11_txt: AssetResource by lazy { init_names_11_melachim_b_11_txt()
      }

  internal val names_11_melachim_b_14_txt: AssetResource by lazy { init_names_11_melachim_b_14_txt()
      }

  internal val names_11_melachim_b_15_txt: AssetResource by lazy { init_names_11_melachim_b_15_txt()
      }

  internal val names_11_melachim_b_16_txt: AssetResource by lazy { init_names_11_melachim_b_16_txt()
      }

  internal val names_11_melachim_b_17_txt: AssetResource by lazy { init_names_11_melachim_b_17_txt()
      }

  internal fun values(): List<AssetResource> = listOf(PyramidCrosswordGuide_txt,
      americanGuide_part1_txt, americanGuide_part2_txt, browseGuide_txt, completeVerseGuide_txt,
      create_sheet_for_open_questions_tutorial_txt, donateText_txt, draft_txt, help_txt,
      mikudGuide_txt, open_questionsGuide_txt, randomApproach_txt, searchExamples_txt,
      searchGuide_txt, shareTextHtml_txt, shareText_txt, simchatTorahMaftir_txt, test2_json,
      test_txt__0, comments_txt, draft2_json, draft_json, pairs_json, test_txt__1, moadim_txt,
      parashot_json, names_10_melachim_a_01_txt, names_10_melachim_a_02_txt,
      names_10_melachim_a_03_txt, names_10_melachim_a_05_txt, names_10_melachim_a_09_txt,
      names_10_melachim_a_10_txt, names_10_melachim_a_11_txt, names_10_melachim_a_14_txt,
      names_10_melachim_a_15_txt, names_10_melachim_a_16_txt, names_10_melachim_a_19_txt,
      names_10_melachim_a_20_txt, names_10_melachim_a_21_txt, names_10_melachim_a_22_txt,
      names_10_melachim_a_txt, names_11_melachim_b_05_txt, names_11_melachim_b_07_txt,
      names_11_melachim_b_08_txt, names_11_melachim_b_09_txt, names_11_melachim_b_11_txt,
      names_11_melachim_b_14_txt, names_11_melachim_b_15_txt, names_11_melachim_b_16_txt,
      names_11_melachim_b_17_txt)
}

private fun init_PyramidCrosswordGuide_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/PyramidCrosswordGuide.txt\")") as String, rawPath =
    "other/PyramidCrosswordGuide.txt")

private fun init_americanGuide_part1_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/americanGuide_part1.txt\")") as String, rawPath =
    "other/americanGuide_part1.txt")

private fun init_americanGuide_part2_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/americanGuide_part2.txt\")") as String, rawPath =
    "other/americanGuide_part2.txt")

private fun init_browseGuide_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/browseGuide.txt\")") as String, rawPath = "other/browseGuide.txt")

private fun init_completeVerseGuide_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/completeVerseGuide.txt\")") as String, rawPath =
    "other/completeVerseGuide.txt")

private fun init_create_sheet_for_open_questions_tutorial_txt(): AssetResource =
    AssetResource(originalPath =
    js("require(\"./assets/other/create_sheet_for_open_questions_tutorial.txt\")") as String,
    rawPath = "other/create_sheet_for_open_questions_tutorial.txt")

private fun init_donateText_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/donateText.txt\")") as String, rawPath = "other/donateText.txt")

private fun init_draft_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/draft.txt\")") as String, rawPath = "other/draft.txt")

private fun init_help_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/help.txt\")") as String, rawPath = "other/help.txt")

private fun init_mikudGuide_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/mikudGuide.txt\")") as String, rawPath = "other/mikudGuide.txt")

private fun init_open_questionsGuide_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/open_questionsGuide.txt\")") as String, rawPath =
    "other/open_questionsGuide.txt")

private fun init_randomApproach_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/randomApproach.txt\")") as String, rawPath =
    "other/randomApproach.txt")

private fun init_searchExamples_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/searchExamples.txt\")") as String, rawPath =
    "other/searchExamples.txt")

private fun init_searchGuide_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/searchGuide.txt\")") as String, rawPath = "other/searchGuide.txt")

private fun init_shareTextHtml_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/shareTextHtml.txt\")") as String, rawPath =
    "other/shareTextHtml.txt")

private fun init_shareText_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/shareText.txt\")") as String, rawPath = "other/shareText.txt")

private fun init_simchatTorahMaftir_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/simchatTorahMaftir.txt\")") as String, rawPath =
    "other/simchatTorahMaftir.txt")

private fun init_test2_json(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/test2.json\")") as String, rawPath = "other/test2.json")

private fun init_test_txt__0(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/other/test.txt\")") as String, rawPath = "other/test.txt")

private fun init_comments_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/pairs/comments.txt\")") as String, rawPath = "pairs/comments.txt")

private fun init_draft2_json(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/pairs/draft2.json\")") as String, rawPath = "pairs/draft2.json")

private fun init_draft_json(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/pairs/draft.json\")") as String, rawPath = "pairs/draft.json")

private fun init_pairs_json(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/pairs/pairs.json\")") as String, rawPath = "pairs/pairs.json")

private fun init_test_txt__1(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/pairs/test.txt\")") as String, rawPath = "pairs/test.txt")

private fun init_moadim_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/parashot/moadim.txt\")") as String, rawPath = "parashot/moadim.txt")

private fun init_parashot_json(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/parashot/parashot.json\")") as String, rawPath =
    "parashot/parashot.json")

private fun init_names_10_melachim_a_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_10_melachim_a-01.txt\")") as String, rawPath =
    "peopleNames/names_10_melachim_a-01.txt")

private fun init_names_10_melachim_a_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_10_melachim_a-02.txt\")") as String, rawPath =
    "peopleNames/names_10_melachim_a-02.txt")

private fun init_names_10_melachim_a_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_10_melachim_a-03.txt\")") as String, rawPath =
    "peopleNames/names_10_melachim_a-03.txt")

private fun init_names_10_melachim_a_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_10_melachim_a-05.txt\")") as String, rawPath =
    "peopleNames/names_10_melachim_a-05.txt")

private fun init_names_10_melachim_a_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_10_melachim_a-09.txt\")") as String, rawPath =
    "peopleNames/names_10_melachim_a-09.txt")

private fun init_names_10_melachim_a_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_10_melachim_a-10.txt\")") as String, rawPath =
    "peopleNames/names_10_melachim_a-10.txt")

private fun init_names_10_melachim_a_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_10_melachim_a-11.txt\")") as String, rawPath =
    "peopleNames/names_10_melachim_a-11.txt")

private fun init_names_10_melachim_a_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_10_melachim_a-14.txt\")") as String, rawPath =
    "peopleNames/names_10_melachim_a-14.txt")

private fun init_names_10_melachim_a_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_10_melachim_a-15.txt\")") as String, rawPath =
    "peopleNames/names_10_melachim_a-15.txt")

private fun init_names_10_melachim_a_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_10_melachim_a-16.txt\")") as String, rawPath =
    "peopleNames/names_10_melachim_a-16.txt")

private fun init_names_10_melachim_a_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_10_melachim_a-19.txt\")") as String, rawPath =
    "peopleNames/names_10_melachim_a-19.txt")

private fun init_names_10_melachim_a_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_10_melachim_a-20.txt\")") as String, rawPath =
    "peopleNames/names_10_melachim_a-20.txt")

private fun init_names_10_melachim_a_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_10_melachim_a-21.txt\")") as String, rawPath =
    "peopleNames/names_10_melachim_a-21.txt")

private fun init_names_10_melachim_a_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_10_melachim_a-22.txt\")") as String, rawPath =
    "peopleNames/names_10_melachim_a-22.txt")

private fun init_names_10_melachim_a_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_10_melachim_a.txt\")") as String, rawPath =
    "peopleNames/names_10_melachim_a.txt")

private fun init_names_11_melachim_b_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_11_melachim_b-05.txt\")") as String, rawPath =
    "peopleNames/names_11_melachim_b-05.txt")

private fun init_names_11_melachim_b_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_11_melachim_b-07.txt\")") as String, rawPath =
    "peopleNames/names_11_melachim_b-07.txt")

private fun init_names_11_melachim_b_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_11_melachim_b-08.txt\")") as String, rawPath =
    "peopleNames/names_11_melachim_b-08.txt")

private fun init_names_11_melachim_b_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_11_melachim_b-09.txt\")") as String, rawPath =
    "peopleNames/names_11_melachim_b-09.txt")

private fun init_names_11_melachim_b_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_11_melachim_b-11.txt\")") as String, rawPath =
    "peopleNames/names_11_melachim_b-11.txt")

private fun init_names_11_melachim_b_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_11_melachim_b-14.txt\")") as String, rawPath =
    "peopleNames/names_11_melachim_b-14.txt")

private fun init_names_11_melachim_b_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_11_melachim_b-15.txt\")") as String, rawPath =
    "peopleNames/names_11_melachim_b-15.txt")

private fun init_names_11_melachim_b_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_11_melachim_b-16.txt\")") as String, rawPath =
    "peopleNames/names_11_melachim_b-16.txt")

private fun init_names_11_melachim_b_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_11_melachim_b-17.txt\")") as String, rawPath =
    "peopleNames/names_11_melachim_b-17.txt")

public actual val SharedRes.assets.other.PyramidCrosswordGuide_txt: AssetResource
  get() = CommonMainAssets19.PyramidCrosswordGuide_txt

public actual val SharedRes.assets.other.americanGuide_part1_txt: AssetResource
  get() = CommonMainAssets19.americanGuide_part1_txt

public actual val SharedRes.assets.other.americanGuide_part2_txt: AssetResource
  get() = CommonMainAssets19.americanGuide_part2_txt

public actual val SharedRes.assets.other.browseGuide_txt: AssetResource
  get() = CommonMainAssets19.browseGuide_txt

public actual val SharedRes.assets.other.completeVerseGuide_txt: AssetResource
  get() = CommonMainAssets19.completeVerseGuide_txt

public actual val SharedRes.assets.other.create_sheet_for_open_questions_tutorial_txt: AssetResource
  get() = CommonMainAssets19.create_sheet_for_open_questions_tutorial_txt

public actual val SharedRes.assets.other.donateText_txt: AssetResource
  get() = CommonMainAssets19.donateText_txt

public actual val SharedRes.assets.other.draft_txt: AssetResource
  get() = CommonMainAssets19.draft_txt

public actual val SharedRes.assets.other.help_txt: AssetResource
  get() = CommonMainAssets19.help_txt

public actual val SharedRes.assets.other.mikudGuide_txt: AssetResource
  get() = CommonMainAssets19.mikudGuide_txt

public actual val SharedRes.assets.other.open_questionsGuide_txt: AssetResource
  get() = CommonMainAssets19.open_questionsGuide_txt

public actual val SharedRes.assets.other.randomApproach_txt: AssetResource
  get() = CommonMainAssets19.randomApproach_txt

public actual val SharedRes.assets.other.searchExamples_txt: AssetResource
  get() = CommonMainAssets19.searchExamples_txt

public actual val SharedRes.assets.other.searchGuide_txt: AssetResource
  get() = CommonMainAssets19.searchGuide_txt

public actual val SharedRes.assets.other.shareTextHtml_txt: AssetResource
  get() = CommonMainAssets19.shareTextHtml_txt

public actual val SharedRes.assets.other.shareText_txt: AssetResource
  get() = CommonMainAssets19.shareText_txt

public actual val SharedRes.assets.other.simchatTorahMaftir_txt: AssetResource
  get() = CommonMainAssets19.simchatTorahMaftir_txt

public actual val SharedRes.assets.other.test2_json: AssetResource
  get() = CommonMainAssets19.test2_json

public actual val SharedRes.assets.other.test_txt: AssetResource
  get() = CommonMainAssets19.test_txt__0

public actual val SharedRes.assets.pairs.comments_txt: AssetResource
  get() = CommonMainAssets19.comments_txt

public actual val SharedRes.assets.pairs.draft2_json: AssetResource
  get() = CommonMainAssets19.draft2_json

public actual val SharedRes.assets.pairs.draft_json: AssetResource
  get() = CommonMainAssets19.draft_json

public actual val SharedRes.assets.pairs.pairs_json: AssetResource
  get() = CommonMainAssets19.pairs_json

public actual val SharedRes.assets.pairs.test_txt: AssetResource
  get() = CommonMainAssets19.test_txt__1

public actual val SharedRes.assets.parashot.moadim_txt: AssetResource
  get() = CommonMainAssets19.moadim_txt

public actual val SharedRes.assets.parashot.parashot_json: AssetResource
  get() = CommonMainAssets19.parashot_json

public actual val SharedRes.assets.peopleNames.names_10_melachim_a_01_txt: AssetResource
  get() = CommonMainAssets19.names_10_melachim_a_01_txt

public actual val SharedRes.assets.peopleNames.names_10_melachim_a_02_txt: AssetResource
  get() = CommonMainAssets19.names_10_melachim_a_02_txt

public actual val SharedRes.assets.peopleNames.names_10_melachim_a_03_txt: AssetResource
  get() = CommonMainAssets19.names_10_melachim_a_03_txt

public actual val SharedRes.assets.peopleNames.names_10_melachim_a_05_txt: AssetResource
  get() = CommonMainAssets19.names_10_melachim_a_05_txt

public actual val SharedRes.assets.peopleNames.names_10_melachim_a_09_txt: AssetResource
  get() = CommonMainAssets19.names_10_melachim_a_09_txt

public actual val SharedRes.assets.peopleNames.names_10_melachim_a_10_txt: AssetResource
  get() = CommonMainAssets19.names_10_melachim_a_10_txt

public actual val SharedRes.assets.peopleNames.names_10_melachim_a_11_txt: AssetResource
  get() = CommonMainAssets19.names_10_melachim_a_11_txt

public actual val SharedRes.assets.peopleNames.names_10_melachim_a_14_txt: AssetResource
  get() = CommonMainAssets19.names_10_melachim_a_14_txt

public actual val SharedRes.assets.peopleNames.names_10_melachim_a_15_txt: AssetResource
  get() = CommonMainAssets19.names_10_melachim_a_15_txt

public actual val SharedRes.assets.peopleNames.names_10_melachim_a_16_txt: AssetResource
  get() = CommonMainAssets19.names_10_melachim_a_16_txt

public actual val SharedRes.assets.peopleNames.names_10_melachim_a_19_txt: AssetResource
  get() = CommonMainAssets19.names_10_melachim_a_19_txt

public actual val SharedRes.assets.peopleNames.names_10_melachim_a_20_txt: AssetResource
  get() = CommonMainAssets19.names_10_melachim_a_20_txt

public actual val SharedRes.assets.peopleNames.names_10_melachim_a_21_txt: AssetResource
  get() = CommonMainAssets19.names_10_melachim_a_21_txt

public actual val SharedRes.assets.peopleNames.names_10_melachim_a_22_txt: AssetResource
  get() = CommonMainAssets19.names_10_melachim_a_22_txt

public actual val SharedRes.assets.peopleNames.names_10_melachim_a_txt: AssetResource
  get() = CommonMainAssets19.names_10_melachim_a_txt

public actual val SharedRes.assets.peopleNames.names_11_melachim_b_05_txt: AssetResource
  get() = CommonMainAssets19.names_11_melachim_b_05_txt

public actual val SharedRes.assets.peopleNames.names_11_melachim_b_07_txt: AssetResource
  get() = CommonMainAssets19.names_11_melachim_b_07_txt

public actual val SharedRes.assets.peopleNames.names_11_melachim_b_08_txt: AssetResource
  get() = CommonMainAssets19.names_11_melachim_b_08_txt

public actual val SharedRes.assets.peopleNames.names_11_melachim_b_09_txt: AssetResource
  get() = CommonMainAssets19.names_11_melachim_b_09_txt

public actual val SharedRes.assets.peopleNames.names_11_melachim_b_11_txt: AssetResource
  get() = CommonMainAssets19.names_11_melachim_b_11_txt

public actual val SharedRes.assets.peopleNames.names_11_melachim_b_14_txt: AssetResource
  get() = CommonMainAssets19.names_11_melachim_b_14_txt

public actual val SharedRes.assets.peopleNames.names_11_melachim_b_15_txt: AssetResource
  get() = CommonMainAssets19.names_11_melachim_b_15_txt

public actual val SharedRes.assets.peopleNames.names_11_melachim_b_16_txt: AssetResource
  get() = CommonMainAssets19.names_11_melachim_b_16_txt

public actual val SharedRes.assets.peopleNames.names_11_melachim_b_17_txt: AssetResource
  get() = CommonMainAssets19.names_11_melachim_b_17_txt
